import classnames from 'classnames';
import {
	BadgeIcon, BodyClickListener, Button, DropDownOption, Icon
} from 'gwx-voyager-components';
import moment from 'moment';
import PropTypes from 'prop-types';
import { stringify } from 'query-string';
import React, { Component } from 'react';
import Preferences from '../../Preferences/Preferences.react';
import Unsubscribe from '../../Preferences/Unsubscribe.react';
import SubscriptionHistory from '../../SubscriptionHistory/SubscriptionHistory.react';
import DeleteEmailConfirmation from '../DeleteEmailConfirmation';
import ResubscribeEmailConfirmation from '../ResubscribeEmailConfirmation.react';
import '../subscription.scss';

/**
 * A Subscription row
 */
class Subscription extends Component {
	constructor(props) {
		super(props);
		this.onClickOptOut = this.onClickOptOut.bind(this);
		this.onClickOptIn = this.onClickOptIn.bind(this);
		this.onClickPreferences = this.onClickPreferences.bind(this);
		this.onClickUnsubscribe = this.onClickUnsubscribe.bind(this);
		this.onClickSendResubscribeEmail = this.onClickSendResubscribeEmail.bind(this);
		this.onCloseSendResubscribeEmailModal = this.onCloseSendResubscribeEmailModal.bind(this);
		this.sendResubscribeEmail = this.sendResubscribeEmail.bind(this);
		this.savePreferences = this.savePreferences.bind(this);
		this.onPreferencesModalClose = this.onPreferencesModalClose.bind(this);
		this.preferencesUpdatedModalClose = this.preferencesUpdatedModalClose.bind(this);
		this.closeOptionsDropdown = this.closeOptionsDropdown.bind(this);
		this.onSubscriptionHistoryModalClose = this.onSubscriptionHistoryModalClose.bind(this);
		this.onClickDeleteEmail = this.onClickDeleteEmail.bind(this);
		this.onClickInactivate = this.onClickInactivate.bind(this);
		this.onDeleteEmailModalClose = this.onDeleteEmailModalClose.bind(this);
		this.state = {
			sendingFacilitySubscriptionStatus: props.sendingFacilitySubscriptionStatus,
			subscriptionDeleted: false,
			providerSubscriptionAdtTypePreference: props.providerSubscriptionAdtTypePreference,
			subscriptionSourceDisplay: props.subscriptionSourceDisplay,
			openDropdowns: {},
			resubscribeEmailModal: null,
			deleteEmailModal: null
		};
	}

	onClickOptOut() {
		this.props.onClickOptOut().then((response) => {
			if (!response || !response.error) {
				this.setState({ sendingFacilitySubscriptionStatus: '2' });
				this.onPreferencesModalClose();
			}
		});
	}

	onClickInactivate(subscriptionId, communityId, isActive, deleteMultiple) {
		this.props.onClickInactivate(subscriptionId, communityId, isActive, deleteMultiple).then((response) => {
			if (response && response.error) {
				this.onClickDeleteEmail(this.props, isActive, response.error.message);
			} else {
				this.onDeleteEmailModalClose();
				this.onCloseSendResubscribeEmailModal();
			}
		});
	}

	onClickOptIn() {
		this.props.onClickOptIn().then((response) => {
			if (!response || !response.error) {
				this.setState({ sendingFacilitySubscriptionStatus: '1' });
				this.onPreferencesModalClose();
			}
		});
	}

	onCloseSendResubscribeEmailModal() {
		this.setState({ resubscribeEmailModal: null });
	}

	sendResubscribeEmail(id, directAddress) {
		this.props.onClickSendResubscribeEmail(id).then((response) => {
			if (response && response.error) {
				this.onClickSendResubscribeEmail(id, directAddress, response.error.message);
			} else {
				this.onDeleteEmailModalClose();
			}
		});
	}

	onClickSendResubscribeEmail(id, directAddress, errorMsg) {
		this.setState({
			resubscribeEmailModal: <ResubscribeEmailConfirmation
				directAddress={directAddress}
				errorMsg={errorMsg}
				onCloseSendResubscribeEmailModal={() => this.onCloseSendResubscribeEmailModal()}
				sendResubscribeEmail={() => this.sendResubscribeEmail(id, directAddress)}
			/>
		});
	}

	onClickPreferences(communityId, subscriptionId) {
		this.setState({
			preferencesModal: <Preferences
				communityId={communityId}
				subscriptionId={subscriptionId}
				onClickOptOut={() => this.onClickOptOut()}
				onClickOptIn={() => this.onClickOptIn()}
				savePreferences={() => this.savePreferences()}
				onPreferencesModalClose={this.onPreferencesModalClose}
				preferencesUpdatedModalClose={this.preferencesUpdatedModalClose}
			/>
		});
	}

	onClickUnsubscribe(communityId, subscriptionId) {
		this.setState({
			preferencesModal: <Unsubscribe
				communityId={communityId}
				subscriptionId={subscriptionId}
				onClickOptOut={() => this.onClickOptOut()}
				onPreferencesModalClose={this.onPreferencesModalClose}
			/>
		});
	}

	onClickHistory(subscriptionId) {
		this.setState({
			historyModal: <SubscriptionHistory
				subscriptionId={subscriptionId}
				onSubscriptionHistoryModalClose={this.onSubscriptionHistoryModalClose}
			/>
		});
	}

	onClickNotifications() {
		if (this.props.npi) {
			this.props.history.push(`/${this.props.communityId}/reporting/notifications?${stringify({
				providerNpi: this.props.npi,
				directAddress: this.props.directAddress,
				sendingFacilityDisplayName: this.props.sendingFacilityDisplayName,
				startDate: moment().utc().subtract(7, 'days').startOf('day').valueOf(),
				endDate: moment().utc().endOf('day').valueOf()
			})}`);
		}
	}

	onClickDeleteEmail(props, isActive, errorMsg) {
		this.setState({
			deleteEmailModal: <DeleteEmailConfirmation
				subscriptionId={props.id}
				communityId={props.communityId}
				communityName={props.communityName}
				npi={props.npi}
				sendingFacilityDisplayName={props.sendingFacilityDisplayName}
				directAddress={props.directAddress}
				isActive={isActive}
				errorMsg={errorMsg}
				onClickInactivate={(deleteMultiple) => this.onClickInactivate(props.id, props.communityId, isActive, deleteMultiple)}
				onDeleteEmailModalClose={this.onDeleteEmailModalClose}
			/>
		});
	}

	onPreferencesModalClose() {
		this.setState({
			preferencesModal: null
		});
	}

	onDeleteEmailModalClose() {
		this.setState({
			deleteEmailModal: null
		});
	}

	savePreferences() {
		this.props.onClickOptIn().then((response) => {
			if (!response || !response.error) {
				this.setState({ sendingFacilitySubscriptionStatus: '1' });
				this.onPreferencesModalClose();
			}
		});
	}

	preferencesUpdatedModalClose(updatedPreference) {
		this.setState({
			preferencesModal: null,
			providerSubscriptionAdtTypePreference: updatedPreference
		});
	}

	onSubscriptionHistoryModalClose() {
		this.setState({
			historyModal: null
		});
	}

	closeOptionsDropdown(cb) {
		this.setState({ openDropdowns: {} }, cb);
	}

	render() {
		if (this.state.subscriptionDeleted) {
			return null;
		}

		const badgeProps = {
			0: {
				iconName: 'question-circle',
				iconStyle: 'text-info',
				tooltip: 'Unsubscribed Address'
			},
			1: {
				iconName: 'check',
				iconStyle: 'text-success',
				tooltip: 'Subscribed Address'
			},
			2: {
				iconName: 'ban',
				iconStyle: 'text-danger',
				tooltip: 'Unsubscribed Address'
			},
			3: {
				iconName: 'check',
				iconStyle: 'text-warning',
				tooltip: 'Subscribed, Preferences Changed From Default'
			},
			16: {
				iconName: 'times-circle',
				iconStyle: 'text-danger',
				tooltip: 'Unsubscribed All'
			},
			32: {
				iconName: 'square',
				iconStyle: 'text-danger',
				tooltip: 'Internal Domain'
			}
		};

		const inactiveBadgeProps= {
			iconName: 'times-circle',
			iconStyle: 'text-secondary',
			tooltip: 'Deleted'
		};

		let actionBtn;
		const dropDownDeleteOption = this.props.isActive===undefined || this.props.isActive? 'Delete' : 'Restore';
		const updateIsActiveStatus = dropDownDeleteOption === 'Delete'? false : true;
		switch (this.state.sendingFacilitySubscriptionStatus) {
			case '0':
				actionBtn = (
					<Button
						className='btn-link'
						id={`${this.props.directAddress}-create-sub-btn`}
						onClick={() => this.props.onClickCreate(this.props.directAddress)}
						title='Create Subscription'
					>
						<Icon iconName='plus' iconStyle='fa-lg' />
					</Button>
				);
				break;
			case '1':
				actionBtn = (
					<div
						className={classnames('dropdown', {
							show: !!this.state.openDropdowns[this.props.id]
						})}
						id={`${this.props.id}-options-dropdown`}
					>
						<Button
							className='btn-link'
							data-toggle='dropdown'
							aria-haspopup='true'
							aria-expanded='false'
							id={`${this.props.id}-options-btn`}
							onClick={() => this.setState((prevState) => ({
								openDropdowns: {
									[this.props.id]: !prevState.openDropdowns[this.props.id]
								}
							}))}
							show={this.state.openDropdowns[this.props.id]}
							title='More Options'
							type='button'
						>
							<Icon iconName='ellipsis-h' iconStyle='fa-lg' tooltip='More Options'/>
						</Button>
						<div
							className='dropdown-menu dropdown-menu-right'
							aria-labelledby={`${this.props.id}-options-btn`}
						>
							{(this.props.isActive === undefined || this.props.isActive) && <DropDownOption
								value='Preferences'
								onClick={() => this.closeOptionsDropdown(
									() => this.onClickPreferences(this.props.communityId, this.props.id)
								)}
							/>}
							{(this.props.isActive === undefined || this.props.isActive) && <DropDownOption
								value='Unsubscribe'
								onClick={() => this.closeOptionsDropdown(
									() => this.onClickUnsubscribe(this.props.communityId, this.props.id)
								)}
							/>}
							<DropDownOption
								value='History'
								onClick={() => this.closeOptionsDropdown(() => this.onClickHistory(this.props.id))}
							/>
							{(this.props.isActive === undefined || this.props.isActive) && <DropDownOption
								value='Notifications'
								onClick={() => this.closeOptionsDropdown(() => this.onClickNotifications(this.props.id))}
							/>}
							<DropDownOption
								value={dropDownDeleteOption}
								onClick={() => this.closeOptionsDropdown(() => this.onClickDeleteEmail(this.props, updateIsActiveStatus))}
							/>
						</div>
					</div>
				);
				break;
			case '2':
				actionBtn = (
					<div
						className={classnames('dropdown', {
							show: !!this.state.openDropdowns[this.props.id]
						})}
						id={`${this.props.id}-options-dropdown`}
					>
						<Button
							className='btn-link'
							data-toggle='dropdown'
							aria-haspopup='true'
							aria-expanded='false'
							id={`${this.props.id}-options-btn`}
							onClick={() => this.setState((prevState) => ({
								openDropdowns: {
									[this.props.id]: !prevState.openDropdowns[this.props.id]
								}
							}))}
							show={this.state.openDropdowns[this.props.id]}
							title='More Options'
							type='button'
						>
							<Icon iconName='ellipsis-h' iconStyle='fa-lg' tooltip='More Options'/>
						</Button>
						<div
							className='dropdown-menu dropdown-menu-right'
							aria-labelledby={`${this.props.id}-options-btn`}
						>
							{(this.props.isActive === undefined || this.props.isActive) && <DropDownOption
								value='Resubscribe'
								onClick={() => this.closeOptionsDropdown(
									() => this.onClickOptIn()
								)}
							/>}
							<DropDownOption
								value='History'
								onClick={() => this.closeOptionsDropdown(() => this.onClickHistory(this.props.id))}
							/>
							{(this.props.isActive === undefined || this.props.isActive) && <DropDownOption
								value='Notifications'
								onClick={() => this.closeOptionsDropdown(() => this.onClickNotifications())}
							/>}
							<DropDownOption
								value={dropDownDeleteOption}
								onClick={() => this.closeOptionsDropdown(() => this.onClickDeleteEmail(this.props, updateIsActiveStatus))}
							/>
						</div>
					</div>
				);
				break;
			case '16':
				actionBtn = (
					<div
						className={classnames('dropdown', {
							show: !!this.state.openDropdowns[this.props.id]
						})}
						id={`${this.props.id}-options-dropdown`}
					>
						<Button
							className='btn-link'
							data-toggle='dropdown'
							aria-haspopup='true'
							aria-expanded='false'
							id={`${this.props.id}-options-btn`}
							onClick={() => this.setState((prevState) => ({
								openDropdowns: {
									[this.props.id]: !prevState.openDropdowns[this.props.id]
								}
							}))}
							show={this.state.openDropdowns[this.props.id]}
							title='More Options'
							type='button'
						>
							<Icon iconName='ellipsis-h' iconStyle='fa-lg' tooltip='More Options' />
						</Button>
						<div
							className='dropdown-menu dropdown-menu-right'
							aria-labelledby={`${this.props.id}-options-btn`}
						>
							{(this.props.isActive === undefined || this.props.isActive) && <DropDownOption
								value='Send Resubscribe Email'
								onClick={() => this.closeOptionsDropdown(
									() => this.onClickSendResubscribeEmail(this.props.id, this.props.directAddress)
								)}
							/>}
							<DropDownOption
								value='History'
								onClick={() => this.closeOptionsDropdown(() => this.onClickHistory(this.props.id))}
							/>
							{(this.props.isActive === undefined || this.props.isActive) && <DropDownOption
								value='Notifications'
								onClick={() => this.closeOptionsDropdown(() => this.onClickNotifications())}
							/>}
							<DropDownOption
								value={dropDownDeleteOption}
								onClick={() => this.closeOptionsDropdown(() => this.onClickDeleteEmail(this.props, updateIsActiveStatus))}
							/>
						</div>
					</div>
				);
				break;
			case '32':
				actionBtn = (
					<div
						className={classnames('dropdown', {
							show: !!this.state.openDropdowns[this.props.id]
						})}
						id={`${this.props.id}-options-dropdown`}
					>
						<Button
							className='btn-link'
							data-toggle='dropdown'
							aria-haspopup='true'
							aria-expanded='false'
							id={`${this.props.id}-options-btn`}
							onClick={() => this.setState((prevState) => ({
								openDropdowns: {
									[this.props.id]: !prevState.openDropdowns[this.props.id]
								}
							}))}
							show={this.state.openDropdowns[this.props.id]}
							title='More Options'
							type='button'
						>
							<Icon iconName='ellipsis-h' iconStyle='fa-lg' tooltip='More Options'/>
						</Button>
						<div
							className='dropdown-menu dropdown-menu-right'
							aria-labelledby={`${this.props.id}-options-btn`}
						>
							<DropDownOption
								value='History'
								onClick={() => this.closeOptionsDropdown(() => this.onClickHistory(this.props.id))}
							/>
							<DropDownOption
								value={dropDownDeleteOption}
								onClick={() => this.closeOptionsDropdown(() => this.onClickDeleteEmail(this.props, updateIsActiveStatus))}
							/>
						</div>
					</div>
				);
				break;
			default:
				actionBtn = (
					<div
						className={classnames('dropdown', {
							show: !!this.state.openDropdowns[this.props.id]
						})}
						id={`${this.props.id}-options-dropdown`}
					>
						<Button
							className='btn-link'
							data-toggle='dropdown'
							aria-haspopup='true'
							aria-expanded='false'
							id={`${this.props.id}-options-btn`}
							onClick={() => this.setState((prevState) => ({
								openDropdowns: {
									[this.props.id]: !prevState.openDropdowns[this.props.id]
								}
							}))}
							disabled
							show={this.state.openDropdowns[this.props.id]}
							title='More Options'
							type='button'
						>
							<Icon iconName='ellipsis-h' iconStyle='fa-lg' tooltip='More Options' />
						</Button>
					</div>
				);
				break;
		}

		let subscriptionPreferenceIndicator;
		if (this.state.sendingFacilitySubscriptionStatus === '2' || this.state.sendingFacilitySubscriptionStatus === '0' || this.state.sendingFacilitySubscriptionStatus === '16' || this.state.sendingFacilitySubscriptionStatus === '32') {
			subscriptionPreferenceIndicator = this.state.sendingFacilitySubscriptionStatus;
		} else if (this.state.sendingFacilitySubscriptionStatus === '1' && this.state.providerSubscriptionAdtTypePreference === this.props.systemDefaultSubscriptionAdtTypePreference) {
			subscriptionPreferenceIndicator = this.state.sendingFacilitySubscriptionStatus;
		} else {
			subscriptionPreferenceIndicator = 3;
		}

		const badgePropsToDisplay = this.props.isActive === undefined || this.props.isActive
			? badgeProps[subscriptionPreferenceIndicator]
			: inactiveBadgeProps;

		const subscriptionSourceDisplay = this.state.subscriptionSourceDisplay === 'MANUAL_NPPES_HPD' ? 'MANUAL - NPPES & HPD' :
			this.state.subscriptionSourceDisplay === 'NPPES_HPD' ? 'NPPES & HPD' : 
			this.state.subscriptionSourceDisplay === 'MANUAL_HPD' ? 'MANUAL - HPD' : 
			this.state.subscriptionSourceDisplay === 'MANUAL_NPPES' ? 'MANUAL - NPPES' : 
			this.state.subscriptionSourceDisplay;
		return (
			<div className='address-subscription' key={this.props.directAddress}>
				<BadgeIcon key={`${this.props.directAddress}-badge`} {...badgePropsToDisplay} />
				{' '}
				{this.props.directAddress}
				{' '}
				<span>
					(
					{subscriptionSourceDisplay || '--'}
					)
				</span>
				<span className='row-actions flex-item' key={`${this.props.directAddress}-action-buttons`}>
					{actionBtn}
				</span>
				{this.state.preferencesModal}
				{this.state.historyModal}
				{this.state.resubscribeEmailModal}
				{this.state.deleteEmailModal}
				<BodyClickListener onClick={() => this.setState({ openDropdowns: {} })} />
			</div>
		);
	}
}

Subscription.defaultProps = {
	lastModifiedDateTime: undefined,
	onClickCreate: () => { }
};
Subscription.propTypes = {
	directAddress: PropTypes.string.isRequired,
	onClickOptOut: PropTypes.func.isRequired,
	onClickInactivate: PropTypes.func.isRequired,
	onClickOptIn: PropTypes.func.isRequired,
	onClickSendResubscribeEmail: PropTypes.func.isRequired,
	onClickCreate: PropTypes.func,
	sendingFacilitySubscriptionStatus: PropTypes.oneOf(['0', '1', '2', '16', '32']).isRequired,
	lastModifiedDateTime: PropTypes.number,
	providerSubscriptionAdtTypePreference: PropTypes.number,
	systemDefaultSubscriptionAdtTypePreference: PropTypes.number
};

export { Subscription as default };
